<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <p>
      Il existe différents contrats d'assurance de CHANTIER/BATIMENT/CONSTRUCTION que l'on peut souscrire en tant que Maître de l'Ouvrage pour protéger sa construction. Ils sont au nombre de 5, et sont souvent inclus dans un package assurance Dommages Ouvrage.
    </p>
    <ul class="insurance-types">
      <li>Assurance Dommages Ouvrage (DO),</li>
      <li>Tous Risques Chantiers (TRC) / Montage Essais,</li>
      <li>RC Décennale Constructeur Non Réalisateur (CNR),</li>
      <li>Responsabilité Civile du Maître de l'Ouvrage (RCMO),</li>
      <li>Contrat Collectif de Responsabilité Décennale (CCRD).</li>
    </ul>
    <p>
      L'assurance dommages ouvrage particulier est une assurance obligatoire qui coûte assez cher au final. Même si vos artisans ont une Assurance Responsabilité Civile Décennale  la Banque qui vous accorde le crédit pour la construction de votre maison Individuelle ou le syndic de l'immeuble dans lequel se trouve votre appartement à rénover vous imposera cette assurance. Ce contrat Dommages Ouvrage est le contrat miroir de l'assurance décennale des artisans. Mais si vous ne comptez que sur l'assurance décennale de vos artisans, en cas de litige après livraison de la construction, vous pourrez attendre 10 ans avoir gain de cause et une prise en charge. Mais avec l'assurance dommage ouvrage obligatoire, vous êtes pris en charge en maximum <span class="highlight-purple">90 jours</span>. 
    </p>
    <p>
      Le courtier en assurances BROKINS dispose de nombreux assureurs spécialisés dans cette assurance, dont un échantillon est listé ci-après : GENERALI, GROUPAMA SPVIE, APRIL QBE, AXRE AMIG, HELVETIA, UBI LLOYD'S
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>QU'EST-CE QUE L'ASSURANCE DOMMAGES OUVRAGE ?</h2>
    <p>
      C'est une assurance obligatoire qui intervient en cas de défauts graves de constructions. Il s'agit de l'assurance miroir (mais payée par client final propriétaire de l'ouvrage à l'assurance décennale des artisans. En effet, elle a pour objet de fournir au propriétaire de l'ouvrage (immeuble, maison, local professionnel ) un préfinancement rapide (sans attendre la décision de la justice statuant sur les responsabilités de chacun) de la totalité des travaux de réparation des dommages les plus lourds subis par la construction ou un remboursement des montants déjà dépensés. Cela se fait avant toute recherche de responsabilités .
    </p>
    <p>
      Cette assurance, qui coûte entre <span class="highlight-purple">1% et 3%</span>du prix de la construction, est une assurance tous risques pour tous les désordres qui vont apparaître après la construction de votre maison du fait de malfaçons etc…. Les statistiques parlent d'elle-même : vous avez <span class="highlight-purple">66%</span> de chance d' avoir besoin de faire appel à cette assurance pendant les <span class="highlight-purple">10 ans</span> de la garantie décennale.
    </p>
    <p>
      En effet, par la suite, la Compagnie d'Assurance de Dommages Ouvrage se débrouille de son côté pour faire jouer l'assurance en 
      responsabilité décennale obligatoire des différents constructeurs/fabricants/importateurs/contrôleurs techniques responsables du 
      dégât/désordre ayant participé aux travaux, afin de récupérer l'indemnité versée au maître d'ouvrage.
    </p>
    <p>
      Par ailleurs, la compagnie fournissant cette garantie doit faire effectuer les travaux nécessaires déterminés à la suite d'une expertise.
    </p>
    <p>
      Le consommateur (le particulier) qui décide de faire réaliser des travaux de construction, devenant à cette occasion le maître d'ouvrage, doit souscrire une assurance de dommages obligatoire, dite de « dommages-ouvrage ».
    </p>

    <p class="highlight-text">
      Le coût assurance dommage ouvrage dans une consutruction ou rénovation peut être conséquent. Demandez donc plusieurs devis.
    </p>
  </div>

  <div class="content-section">
    <h2>QUE COUVRE CETTE ASSURANCE ?</h2>
    <h3>L'ouvrage en tant que tel :</h3>
    <p>
      Dans le cadre de travaux de construction, l'assurance Dommages Ouvrage couvre les vices, les malfaçons qui menacent la solidité 
      de la construction, même résultat d'un vice du sol, et des désordres qui remettent en cause la destination de l'ouvrage. 
      Elle s'applique pour :
    </p>
    <ul class="coverage-list">
      <li>Un effondement de toiture,</li>
      <li>Des fissures importantes des murs (non superficielles)</li>
      <li>Un affaissement de plancher,</li>
      <li>Des défauts d'isolation thermique des murs,</li>
      <li>…</li>
    </ul>
    
    <div class="case-study">
      <h4>CAS PRATIQUE :</h4>
      <p>
        Si vous constatez un défaut de performance énergétique de votre logement et que vous envisagez de faire intervenir l'assurance dommages-ouvrage, elle ne pourra intervenir qu'en cas de dommages à l'ouvrage conduisant à une surconsommation énergétique ne permettant l 'utilisation du logement qu'à un coût exorbitant. Vous devrez également justifier que vous avez bien respecté toutes les conditions d'utilisation et d'entretien.
      </p>
    </div>

    <p>De même pour les dommages qui rendent la maison habitable ou qui nuisent gravement à son occupation normale ou qui mettent en danger 
    la sécurité des occupants, par exemple :</p>
    <ul class="coverage-list">
      <li>Des infiltrations d'eau à l'intérieur du logement,</li>
      <li>Un soulèvement du carrelage,</li>
      <li>Une rupture de canalisation encastrée,</li>
      <li>Une insuffisance manifeste du chauffage.</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>QUI DOIT SOUSCRIRE UNE ASSURANCE DOMMAGES OUVRAGE ?</h2>
    <p>
      Le maître d'ouvrage, toute personne physique ou morale qui fait construire ou qui fait réaliser des travaux sur existants (parties anciennes de l'ouvrage), doit souscrire une assurance Dommages Ouvrage.
    </p>
    <p>Il existe plusieurs catégories de maître d'ouvrage :</p>
    <ul class="who-list">
      <li>Les promoteurs immobiliers ou les vendeurs (mais seul le premier vendeur est soumis à l'obligation légale de souscription) , qui doivent la souscrire pour les propriétaires successifs ;</li>
      <li>Le Constructeur de Maison Individuelle, appelé un CMI ;</li>
      <li>Mandataire du propriétaire (administrateur de bien, syndic de copropriété, maître d'ouvrage délégué…) ;</li>
      <li>Une entreprise faisant construire des locaux pour ses besoins propres ;</li>
      <li>Un marchand de biens qui vend des logements réhabilités ou en cours de réhabilitation ;</li>
      <li>Un investisseur faisant construire à des fins locatives ;</li>
      <li>Le particulier lorsqu'il est sollicité directement avec le constructeur (entrepreneur, architecte etc…) ;</li>
      <li>Le particulier lorsqu'il achète une maison construite depuis moins de <span class="highlight-purple">10 ans</span>. En effet, le contrat d'assurance Dommages Ouvrage doit lui être remis au moment de la vente. L'acte de vente doit préciser le nom de l'assureur et le numéro de contrat. Mieux vaut cependant en réclamer une copie au notaire, car en cas de désordre, le nouveau propriétaire est concerné par les informations données dans le présent document et il pourra bénéficier de la couverture de cette assurance.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2>POURQUOI SOUSCRIRE UNE PROTECTION DOMMAGES OUVRAGE ?</h2>
    <p>
      L'assurance Dommages Ouvrage donne au maître d'ouvrage une certitude d'obtenir des réparations, puisque la garantie est maintenue jusqu'à l'expiration des dix ans qui suivent la réception de l'ouvrage.
    </p>
    <p>
      De plus le règlement des sinistres est plus rapide : En effet, l'indemnisation est de <span class="highlight-purple">90 jours</span> en moyenne avant toute recherche des responsabilités. Dans tous les cas, le paiement est effectué dans un délai qui ne peut légalement pas excéder <span class="highlight-purple">225 jours</span>. Une telle rapidité est possible au moyen de la procédure stricte de règlement des sinistres fixée par les clauses types édictées par l'article A.243-1 du code des assurances, devait se conformer aux contrats d'assurance de dommages à l'ouvrage .
    </p>
    <p>
      De même les sinistres sont généralement moins justifiés, puisqu'un règlement avec intervention de la justice coûte en moyenne quatre fois plus cher. En effet, sans cette assurance, les sinistres sont réglés au terme d'une période assez longue et au cours de laquelle les dommages non réparés s'aggravent, et donc le coût des réparations s'accroît.
    </p>
    <p>
      Enfin la gestion des sinistres est beaucoup moins conflictuelle que par le recours à la justice, ce qui permet d'éviter une détérioration des relations entre le maître d'ouvrage et les constructeurs.
    </p>

    <p>
      En cas de non-souscription de l'option CNR (Constructeur Non-Réalisateur : Option payante) complémentaire à l'Assurance Dommage Ouvrage, si le maître d'ouvrage revend l'ouvrage dans un délai de moins de dix ans suivant l'achèvement de sa construction, il est personnellement et financièrement responsable vis-à-vis du nouvel acquéreur de toutes les conséquences résultant du défaut d'assurance.
    </p>
    <p>
      Dans le cadre d'un contrat de construction avec ou sans fourniture de plan, le constructeur ou l'entrepreneur pourrait refuser de l'exécuter, car l'assurance Dommages Ouvrage est un élément obligatoire.
    </p>
    <p>
      Pire, dans le cas du financement de la construction par un crédit bancaire, la banque refusait de l'octroyer.
    </p>
    <p>
      L'assurance Dommages Ouvrage est une assurance relativement chère, ce qui pousse les particuliers à s'en passer. Cependant l'article L 243-3 du code des assurances prévoie des sanctions pénales en cas de défaut de souscription, à savoir un emprisonnement de six mois et une amende de <span class="highlight-purple">75 000€</span> ou de l'une de ces deux peines seulement, il prévoit également que cette peine n'est pas applicable à "la personne physique construisant un logement pour l'occuper elle-même ou le faire occuper par son conjoint, ses ascendants, ses descendants ou ceux de son conjoint, et qu'il finance la construction sans faire appel à un crédit bancaire bien évidement, car comme indiqué plus haut, la banque refusera d'octroyer un crédit de construction si l'assuré ne souscrit par cette assurance ».
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>LA PROTECTION DOMMAGES OUVRAGE EST OBLIGATOIRE SELON :</h2>
    
    <h3>Construction d'un ensemble comprenant une structure, un clos et un couvert :</h3>
    <p>
      C'est également sur la base de ce critère que les juges viennent à retenir la qualification d'ouvrage pour des travaux de rénovation dès qu'ils portent sur des parties de l'immeuble existant ayant pour finalité d'assurer le clos et le couvert. Ainsi, des travaux de ravalement ou de peinture, normalement entendus comme des actes d'entretien d'un ouvrage déjà existant, peuvent recevoir la qualification d'ouvrage dès qu'ils ont une fonction d'étanchéité de la façade du bâtiment. Même raisonnement agissant de la réalisation d'un complexe d'isolation et d'étanchéité sur un immeuble. Donc la construction d'une véranda est un ouvrage.
    </p>

    <h3>L'importance des travaux :</h3>
    
    <h4>Les travaux de réhabilitation</h4>
    <ul class="detail-list">
      <li>S'ils peuvent compromettre la solidité de l'ouvrage (touchant la structure comme extension verticale, extension horizontale, la modification d'un mur porteur) ou des éléments d'équipement indissociables (canalisations, ventilation électrique, menuiserie extérieure châssis de porte) ,</li>
      <li>o S'ils peuvent rendre la construction impropre à sa destination (toiture…) ,</li>
      <li>D'importants travaux de réhabilitation d'un immeuble comportant le ravalement des façades, le remplacement des parties pourries, l'assainissement des lieux humides, le piquetage et le rebouchage des fissurations, la pose d'une dalle, la réfection des murs, toiture , cloisons, le percement des trémies, l'édification des murs des cages d'ascenseurs, l'installation de ceux-ci, la création de salles de bains.</li>
    </ul>

    <h4>Les travaux de rénovation</h4>
    <ul class="detail-list">
      <li>Les travaux de rénovation affectant la structure de l'immeuble sont, par leur importance, assimilables à un ouvrage (Cass., Civ. III, 02 octobre 2002, n° 01-10.241) ,</li>
      <li>Le traitement d'un immeuble (sauf rez-de-chaussée) contre des insectes xylophages,</li>
      <li>La pose d'une installation de climatisation en considération de « sa conception, son ampleur, et l'emprunt de ses éléments à la construction immobilière »,</li>
      <li>Les travaux de rénovation affectant la structure de l'immeuble étant, par leur importance, assimilables à un ouvrage,</li>
      <li>Des travaux confortatifs de reprise de l'existant peuvent être assimilés à des travaux de construction d'un ouvrage,</li>
      <li>Le démontage et la remise en état de certaines parties de garde-corps qui ne se limitent pas à un simple rafraîchissement, mais cohérent en réalité à une rénovation lourde qui s'apparente aux travaux visés par l'article 1792 du Code civil,</li>
      <li>La restauration des pierres de façade qui a pour mais de maintenir l'étanchéité nécessaire à la destination de l'immeuble et qui constitue une opération de restauration lourde, d'une ampleur particulière compte tenu de la valeur architecturale de l'immeuble et de son exposition aux embruns océaniques</li>
    </ul>

    <h3>Lorsqu'il y a une atteinte à l'essence du bâtiment :</h3>
    <ul class="detail-list">
      <li><strong>Cas du ravalement de façade</strong> Cassation, 12/06/2014 : le ravalement d'un immeuble peut être un ouvrage lorsqu'il ne concerne pas seulement l'aspect extérieur, mais remédie à la pathologie des murs et en assure la protection.</li>
      <li><strong>Cas de l'étanchéité,</strong> devant être nécessaire, est l'objet principal du contrat (Cassation, 04/04/2013).</li>
    </ul>

    <h3>Lorsqu'il s'agit de l'immobilisation d'une structure dans le sol :</h3>
    <p>
      L'implantation de bungalows par exemple, car ces habitations n'étaient pas de simples assemblages de bois posés sur le sol et immobilisés par leur propre poids, mais étaient fixés sur des plots et longrines en béton par des plaques de fer, de telle sorte qu'ils ne pouvaient être ni déplacés ni transportés (Cass., Civ. III, 28 janvier 2003, n° 01-13358).
    </p>
  </div>

  <div class="content-section">
    <h2>LA PROTECTION DOMMAGES OUVRAGE N'EST PAS OBLIGATOIRE POUR :</h2>
    
    <h3>Les travaux courants tels que l'entretien ou la décoration n'en sont pas accélérés</h3>
    <ul class="exclusion-list">
      <li>Les travaux de décorations (peinture intérieur, lambris, agencement de mobilier) ,</li>
      <li>Les travaux d'entretien courants ne sont pas soumis à l'obligation d'assurance. Cette notion, qui est d'application stricte, comprend (travaux de maintenance de niveau 1 et 2 et 3) :
        <ul>
          <li>Les travaux d'entretien qui ont pour mais de maintenir dans leur état initial les ouvrages existants, sans changer leur usage ni la nature des prestations qu'ils peuvent offrir ;</li>
          <li>Le petit entretien qui s'entend de travaux répétitifs sur des ouvrages endommagés par un usage courant.</li>
        </ul>
      </li>
    </ul>
    <p>
      Sont exclus des travaux d'entretien, les travaux d'amélioration , de réfection et de réhabilitation (travaux de maintenance de niveau 4 et 5) .
    </p>

    <h3>En revanche, ne sont pas qualifiés d'ouvrage :</h3>
    <ul class="exclusion-list">
      <li>La simple pose de carrelage dans un appartement,</li>
      <li>La mise en place d'une isolation thermique de façade n'entraînant aucune atteinte ou modification à la surface nécessitant seulement un nettoyage préalable du support,</li>
      <li>La réalisation d'une installation de chauffage les différents éléments de l'installation ayant fait l'objet de commandes distinctes, aucune société n'ayant assumé l'installation globale,</li>
      <li>Une rénovation légère de façade consistante en un grattage de toutes les parties dégradées</li>
    </ul>
  </div>

  <div class="content-section bg-accent">
    <h2>QUELS SONT LES RISQUES QUE LA DO NE PREND PAS EN CHARGE ?</h2>
    <p>Pendant les travaux, l'assurance dommages ouvrage ne prend pas en compte les :</p>
    <ul class="not-covered-list">
      <li>Les sinistres survenant pendant les travaux qui illuminent l'assurance MULTIRISQUE PROFESSSIONNEL (Assurance Dommages) de l'entrepreneur (exemple : incendie, vol de matériaux, vol de matériel, dommages des dommages des travaux, …) ;</li>
      <li>Le non-achèvement des travaux dans les délais prévus, qui est prévu et couvert par d'autres garanties (garantie financière d'achèvement, la garantie de remboursement) ;</li>
      <li>Les travaux courants tels que l'entretien ou la décoration qui n'en sont pas accélérés.</li>
      <li>Les dommages esthétiques, car il ne relève pas de la responsabilité décennale. Aussi, le maître d'ouvrage devra agir sur le fondement de la responsabilité contractuelle. À titre d'exemple de dommages esthétiques, citons de minces fissures filiformes, des décollements ponctuels de surface d'une terrasse. Mais la conséquence d'un dommage esthétique sera appréciée d'autant plus sévèrement que le standing ou le luxe de l'immeuble est élevé.</li>
    </ul>

    <h3>Cas pratique :</h3>
    <div class="case-study">
      <p>
        Vous avez acheté une maison dans une copropriété. Dans ce cas, il existe des parties communes (voirie…) et des équipements collectifs. Il faut distinguer si le désordre aﬀecte une partie privative ou une partie commune. Dans le doute, reportez-vous au règlement de copropriété. Le syndic effectue les démarches pour les parties communes.
      </p>
      <p>
        Vous avez fait votre maison sur un terrain situé dans un lotissement.
      </p>
      <p>
        La propriété, la gestion et l'entretien des parties communes et des équipements collectifs sont généralement assurés par une association syndicale libre. C'est elle qui se chargera de faire une déclaration de sinistre en cas de désordre sur une partie commune.
      </p>
    </div>
  </div>

  <div class="content-section">
    <h2>POINT DE DEPART ET DUREE DE LA GARANTIE</h2>
    <p>
      Elle commence au plus tôt, il est recommandé de souscrire une assurance Dommages Ouvrage avant l'ouverture du chantier, et elle prend fin <span class="highlight-purple">10 ans</span> après la réception de l'ouvrage.
    </p>
    <p>
      La réception a lieu en présence du ou des constructeurs quand les travaux sont terminés. Elle marque le point de départ des différentes garanties légales dues par les constructeurs.
    </p>

    <h3>Il y a trois types de réception :</h3>
    <ul class="reception-types">
      <li><strong>La réception expresse,</strong> le maître d'ouvrage signe, avec le ou les constructeurs, à la fin des travaux un procès-verbal de réception dans lequel il indique, s'il y en a, des défauts visibles ou les travaux prévus, mais non exécutés (réserves à la construction).</li>
      <li><strong>La réception tacite,</strong> elle n'est pas formelle, il n'y a pas de procès-verbal signé par le maître d'ouvrage, elle est faite à l'amiable.</li>
      <li><strong>La réception judiciaire,</strong> elle est envisagée lorsque le maître d'ouvrage refuse les travaux, et il n'y a pas de solutions à l'amiable possibles.</li>
    </ul>

    <p>Cependant il est nécessaire de distinguer l'apparition des risques dans le temps.</p>

    <h3>Avant la réception de l'ouvrage par le maître d'ouvrage :</h3>
    <p>
      En cas de malfaçons ou défauts constatés en cours de chantier, la protection Dommages Ouvrage permet le paiement des réparations si :
    </p>
    <ul>
      <li>Le maître d'ouvrage a effectué une mise en demeure restée infructueuse auprès de l'entreprise de construction ;</li>
      <li>Et que le contrat de louage conclu avec l'entrepreneur soit résilié pour inexécution de ses obligations (faillite de l'entrepreneur…).</li>
    </ul>
    <p><strong>La protection Dommages Ouvrage n'est pas une garantie de bonne fin de votre ouvrage.</strong></p>

    <h4>Ne sont pas couverts par cette assurance :</h4>
    <ul class="not-covered-list">
      <li>Les sinistres accidentels survenant pendant les travaux qui relèvent de l'assurance professionnelle de l'entrepreneur (incendie, foudre, explosion, dommage électrique, dégât des eaux, tempête, grêle, inondation, poids de la neige, glissement de terrain, coulée de boue, tremblement de terre, éruption volcanique, malveillance, inexpérience, fausse manœuvre, vandalisme, erreur de conception ou de calcul ou de plan (détectées pendant les travaux par le constructeur et retardant ses travaux), de matière, grève, émeute, mouvement populaire, terrorisme, sabotage…)</li>
      <li>Le non-achèvement des travaux dans les délais prévus, qui est prévu et couvert par d'autres garanties ;</li>
      <li>Relevant de l'esthétisme pur de l'ouvrage.</li>
    </ul>
  </div>

  <div class="content-section bg-light">
    <h2>Pendant la 1ère année après la réception de l'ouvrage</h2>
    <p>
      Au cours de l'année qui suit la réception des travaux, le maître d'ouvrage bénéficie d'une garantie de parfait achèvement. Cette 
      garantie impose à l'entreprise qui a réalisé les travaux de réparations de tous les désordres signalés au cours de l'année qui 
      suit la réception des travaux, quelles que soient leur importance et leur nature.
    </p>
    <p>Les éléments couverts par cette garantie sont notamment :</p>
    <ul class="coverage-list">
      <li>Les canalisations ;</li>
      <li>Les tuyauteries ;</li>
      <li>Les revêtements ;</li>
      <li>Les portes et fenêtres.</li>
    </ul>
    <p>
      Pour faire jouer la garantie de parfait achèvement, le maître d'ouvrage doit sans attendre adresser une lettre recommandée avec 
      avis de réception à l'entreprise concernée en indiquant les désordres.
    </p>
    <p>Le délai pour effectuer les réparations doit être fixé d'un commun accord entre l'entreprise et lui.</p>
    <p>
      Si l'entreprise n'intervient pas dans le délai fixé, vous pouvez saisir le tribunal compétent en fonction du montant du litige.
    </p>
  </div>

  <div class="content-section">
    <h2>Pendant la 2e année après la réception de l'ouvrage</h2>
    <p>
      Durant les 2 ans qui suivent la réception des travaux, vous bénéficiez de la garantie biennale, plus connue sous le nom de 
      Garantie de Bon Fonctionnement. Cette garantie impose à l'entreprise qui a réalisé les travaux de réparer ou remplacer les 
      éléments d'équipement dits dissociables, qui ne fonctionnent pas correctement pendant les 2 années qui suivent la réception 
      des travaux.
    </p>

    <h3>L'on distingue 2 typologies d'équipements :</h3>
    
    <h4>Bien d'équipement Indissociable</h4>
    <p>
      La protection Dommages Ouvrage intervient aussi pour les dommages affectant la solidité des éléments d'équipement qui ne peuvent 
      pas être dissociés de l'ouvrage (fixés solidement à l'ouvrage de viabilité, de fondation, d'ossature, de clos ou de couvert). 
      Les biens d'équipement indissociables sont ceux dont la dépose, le démontage ou le remplacement ne peut s'effectuer sans abîmer 
      ou enlever une partie de l'ouvrage fondamental qui lui sert de support (Chauffage central, huisserie de porte ou de fenêtre…). 
      Ces biens d'équipements indissociables ne sont pas garantis par la garantie de Bon Fonctionnement, mais par la Garantie 
      Responsabilité Civile Décennale.
    </p>

    <div class="examples-section">
      <p><strong>EXEMPLE 1 :</strong> Les travaux de peinture de bassin de piscine : CA 1re A2, 12/02/2006, RG 05/1508. Relèvent de 
      la garantie décennale énoncée par les article 1792 et suivants du Code civil, les travaux de peinture du bassin d'une piscine 
      qui, bien que la piscine ait préexisté à ces travaux, lui sont indissociables, dès lors que la peinture n'avait pas une finalité 
      simplement esthétique, mais était également destinée à un traitement anti-abrasion et anti salissures des parois et que le 
      désordre consistant en une opacité de l'eau a empêché l'exploitation de la piscine pour des raisons de sécurité, la rendant 
      ainsi impropre à son usage. Donc la garantie décennale était applicable.</p>

      <p><strong>EXEMPLE 2 :</strong> L'inaccessibilité d'un ouvrage aux personnes handicapées : Cass.3e civ. Du 05/11/2013-n°12-25417. 
      Les juges considèrent que l'inaccessibilité d'un ouvrage aux personnes handicapées porte atteinte à sa destination. De ce fait, 
      le non-respect des normes sur ce sujet compromet la destination de l'ouvrage. Donc la garantie décennale était applicable.</p>

      <p><strong>EXEMPLE 3 :</strong> La réglementation parasismique. Par un arrêt du 25/05/2005, la Haute juridiction a considéré que 
      « les défauts de conformité aux règlements parasismiques étaient multiples, portaient sur des éléments essentiels de la 
      construction et constituaient un facteur d'ores et déjà avéré et certain de perte de l'ouvrage par séisme, la cour d'appel a pu 
      en déduire que la garantie décennale était applicable.</p>
    </div>

    <h4>Bien d'équipement dissociable</h4>
    <p>
      La jurisprudence stipule qu'un élément d'équipement n'est dissociable que sur un ouvrage neuf. (La Cour de Cassation est venue 
      rappeler qu'il n'existait pas d'élément d'équipement dissociable sur des existants). Seuls ces équipements sont couverts par la 
      Garantie de bon fonctionnement.
    </p>
    <p>
      Exemples de biens d'équipements dissociables : le ballon d'eau chaude, chaudière, radiateur, les volets, fenêtres, interphones, 
      systèmes de sonorisation, plafonds suspendus, moquettes, carrelages simplement collés, revêtement de peinture, papier peint, 
      toiture végétalisée, porte, cloison amovible, robinetterie, douchette, plaque électrique de cuisson …
    </p>

    <p>
      L'assurance prend en charge uniquement les travaux de réparation des dommages couverts par la garantie décennale obligatoire due 
      par les constructeurs. C'est-à-dire, si votre artisan maçon n'est pas couvert pour son activité professionnelle (il a fourni une 
      fausse assurance), en cas de dommage sur votre maison dû à une erreur de celui-ci, votre assurance Dommages Ouvrage ne sera pas 
      applicable.
    </p>
    <p>
      Pour faire jouer la garantie biennale, le maître d'ouvrage doit sans attendre adresser une lettre recommandée avec avis de 
      réception à l'entreprise de construction concernée en indiquant les désordres et en lui demandant d'intervenir à ses frais au 
      plus vite.
    </p>
    <p>
      Si l'entreprise n'intervient pas dans le délai fixé, vous pouvez saisir le tribunal compétent en fonction du montant du litige.
    </p>
  </div>

  <div class="content-section bg-accent">
    <h2>Pendant les 10 ans après la réception de l'ouvrage</h2>
    <p>
      L'assurance de Dommages Ouvrage prend effet après l'expiration du délai de garantie de parfait achèvement, visé à l'article 
      1792-6 du Code civil et fixé à une année suivant la réception des travaux, et expire en même temps que la garantie décennale, 
      soit une durée de 9 années. En effet, la première année est prise en charge par la garantie de parfait achèvement.
    </p>
    <p>Cette garantie impose à l'entreprise de construction de réparer les dommages GRAVES. Ces dommages sont catégorisés selon qu'ils :</p>
    <ul class="damage-categories">
      <li>Compromettent la solidité du bâti (risque d'effondrement de la toiture, fissures importantes des murs, affaissement de 
          plancher, défauts d'isolation thermique des murs, fondations, ossature…) ;</li>
      <li>Rendent la construction inhabitable ou dangereuse pour les occupants (défaut d'étanchéité, fissures importantes, des 
          infiltrations d'eau à l'intérieur du logement, soulèvement du carrelage, rupture de canalisation encastrée, insuffisance 
          manifeste du chauffage rendant l'habitation invivable…).</li>
    </ul>
    <p>
      Le maître de l'ouvrage doit signaler les désordres à l'assureur Dommages Ouvrage au titre de son assurance construction 
      dommages-ouvrage par lettre recommandée avec avis de réception pour obtenir une réparation rapide de ses dommages. Il n'a pas à 
      rentrer en contact avec le constructeur au-delà de la première année.
    </p>
  </div>

  <div class="content-section">
    <h2>COMMENT DECLARER UN SINISTRE A L'ASSUREUR ?</h2>
    <p>
      La procédure de règlement d'un sinistre dommages-ouvrage est encadrée. Elle nécessite de respecter un certain cadre pour obtenir 
      une indemnisation rapide.
    </p>
    <p>Votre déclaration doit préciser dans tous les cas :</p>
    <ul class="declaration-requirements">
      <li>Le numéro du contrat d'assurance ;</li>
      <li>Le nom du propriétaire et l'adresse de la construction endommagée ;</li>
      <li>La date de réception des travaux ou, à défaut, la date de première occupation des lieux ;</li>
      <li>La date d'apparition des désordres ainsi que leur description et leur localisation dans la construction ;</li>
      <li>Le cas échéant, les mesures d'urgence que vous avez dû prendre.</li>
    </ul>

    <h3>En cas de sinistre survenu dans l'année qui suit la réception</h3>
    <p>
      Vous devez joindre, en plus, la copie de la mise en demeure faite auprès du constructeur pour l'obliger à intervenir au titre de 
      sa garantie de parfait achèvement. N'oubliez pas qu'une déclaration incomplète oblige l'assureur à vous réclamer les renseignements 
      manquants et que cela retardera d'autant le règlement de votre sinistre. Votre déclaration doit être adressée à l'assureur en 
      recommandé avec demande d'avis de réception.
    </p>
    <p>
      Si votre sinistre est garanti par l'assureur, une offre d'indemnité vous sera présentée dans un délai maximal de 90 jours à compter 
      de la réception de la déclaration du sinistre. Si vous acceptez cette offre d'indemnisation, elle devra être versée par votre 
      assureur dans un délai de 15 jours. Si les délais mentionnés ci-dessus ne sont pas respectés (sauf situation exceptionnelle) ou si 
      vous estimez que l'offre d'indemnité est manifestement insuffisante, vous pouvez engager les dépenses nécessaires à la réparation 
      des dommages, après en avoir informé votre assureur. Dans ce cas, l'indemnité versée sera majorée de plein droit d'un intérêt égal 
      au double du taux de l'intérêt légal.
    </p>
  </div>

  <div class="content-section bg-light">
    <h2>DIFFERENCE ENTRE ASSURANCE DOMMAGES OUVRAGE ET ASSURANCE DECENNALE ?</h2>
    <p>
      L'assurance responsabilité civile décennale est l'assurance obligatoire que doit souscrire tout professionnel impliqué dans une 
      construction. Elle intervient lorsque la responsabilité du constructeur est mise en jeu sur le fondement de l'article 1792 du Code civil.
    </p>
    <p>
      Le maître d'ouvrage quant à lui s'assure en dommages ouvrage pour disposer, en cas de sinistre, d'un préfinancement, donc d'une 
      procédure rapide, pendant 10 ans, sans attendre une éventuelle décision de justice statuant sur la responsabilité du constructeur.
    </p>

    <div class="comparison-table">
      <h3>Principales différences :</h3>
      <ul class="differences-list">
        <li><strong>Souscripteur :</strong> Constructeur pour la RC Décennale, Maître d'ouvrage pour la DO</li>
        <li><strong>Exemption :</strong> Pour l'assurance DO, seuls l'Etat ainsi que toute personne morale de droit public ou privé 
            lorsqu'elles réalisent pour leur compte des travaux autres qu'habitation et que les seuils suivants soient respectés :
          <ul>
            <li>Total du dernier bilan : supérieur à 6,2 millions €</li>
            <li>Chiffre d'affaires du dernier exercice : supérieur à 12,8 millions €</li>
            <li>Nombre d'employés en moyenne au cours du dernier exercice supérieur à 250</li>
          </ul>
        </li>
        <li><strong>Lien entre les deux assurances :</strong> Il n'est pas possible de souscrire une assurance DO si le/les 
            constructeur(s) n'a(ont) pas d'assurance RC Décennale</li>
        <li><strong>Prise d'effet :</strong> La DO démarre dès le début du chantier, la RC Décennale prend effet à la réception des 
            travaux</li>
        <li><strong>Type de garantie :</strong> La DO est une assurance de chose (votre ouvrage), qui couvre sans recherche de 
            responsabilité, les dommages de nature physique décennale</li>
      </ul>
    </div>

    <h3>Ce que couvre l'assurance Dommages Ouvrage :</h3>
    <p>
      L'assurance DO préfinance la totalité des travaux de réparation du dommage comprenant éventuellement le coût d'une partie 
      d'ouvrage manquante (absence d'ouvrage), constituant le seul remède au dommage, même s'il en résulte un enrichissement pour le 
      maître de l'ouvrage.
    </p>
    <p>Elle ne couvre pas les conséquences immatérielles ou mobilières du dommage.</p>
    <p>Elle couvre les dommages apparus :</p>
    <ul class="coverage-timeline">
      <li>Avant la réception après mise en demeure restée infructueuse, la résiliation du contrat pour inexécution doit avoir été 
          prononcée</li>
      <li>À la réception et pendant la période de parfait achèvement, à défaut de réparation au titre de l'art 1792-6 C. civ</li>
      <li>Après la période de parfait achèvement</li>
    </ul>

    <h3>Ce que couvre l'assurance RC Décennale :</h3>
    <p>
      L'assurance RC décennale couvre le domaine de la présomption de responsabilité des art 1792 et 1992-2 C.civ (dommages 
      compromettant la solidité de l'ouvrage ou des éléments d'équipement indissociables ou rendant l'immeuble impropre à sa destination). 
      Elle est limitée au secteur d'activité déclaré à l'assureur.
    </p>
    <p>L'assurance RC décennale couvre :</p>
    <ul class="rc-coverage">
      <li>Les dommages matériels consécutifs à des vices cachés à la réception</li>
      <li>Les dommages résultant de l'absence d'ouvrage s'ils sont de nature décennale</li>
      <li>Mais ne couvre pas les dommages immatériels ou mobiliers</li>
    </ul>

    <p>
      Ensuite, c'est l'assureur Dommages Ouvrage qui se débrouille (exerce un recours) auprès des assureurs Responsabilité Civile 
      Décennale du(des) constructeurs en tort pour obtenir un remboursement des sommes versées à l'assuré.
    </p>
  </div>
</app-page-layout>
